import React from 'react';
import { motion } from 'framer-motion';
interface MarketSizeComparisonProps {
  swedenValue: number;
  globalValue: number;
  swedenLabel: string;
  globalLabel: string;
}
export function MarketSizeComparison({
  swedenValue,
  globalValue,
  swedenLabel,
  globalLabel
}: MarketSizeComparisonProps) {
  // Calculate relative sizes (clamped for visual balance)
  const ratio = globalValue / swedenValue;
  const swedenSize = 100;
  const globalSize = Math.min(swedenSize * Math.sqrt(ratio), 300); // Sqrt for area perception
  return <div className="flex items-end justify-center gap-16 h-64" data-id="element-264">
      {/* Sweden Circle */}
      <div className="flex flex-col items-center gap-4" data-id="element-265">
        <motion.div className="rounded-full bg-[#4fd1c5]/20 border-2 border-[#4fd1c5] flex items-center justify-center relative" style={{
        width: swedenSize,
        height: swedenSize
      }} initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        type: 'spring',
        damping: 12
      }} data-id="element-266">
          <span className="text-white font-bold" data-id="element-267">{swedenValue}B</span>
        </motion.div>
        <span className="text-white/70 font-medium" data-id="element-268">{swedenLabel}</span>
      </div>

      {/* Global Circle */}
      <div className="flex flex-col items-center gap-4" data-id="element-269">
        <motion.div className="rounded-full bg-[#ffd700]/20 border-2 border-[#ffd700] flex items-center justify-center relative" style={{
        width: globalSize,
        height: globalSize
      }} initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        type: 'spring',
        damping: 12,
        delay: 0.2
      }} data-id="element-270">
          <span className="text-white font-bold text-2xl" data-id="element-271">{globalValue}B</span>
        </motion.div>
        <span className="text-[#ffd700] font-medium" data-id="element-272">{globalLabel}</span>
      </div>
    </div>;
}